// extracted by mini-css-extract-plugin
export default {"carrinho":"Carrinho_carrinho__GlPMV","total":"Carrinho_total__eWgvE"};